import { render, staticRenderFns } from "./PerformanceOrders.vue?vue&type=template&id=76ba2483"
import script from "./PerformanceOrders.vue?vue&type=script&lang=js"
export * from "./PerformanceOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports